module.exports = __webpack_public_path__ + "static/img/ARAD4_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD4_2.png
// module id = TnRd
// module chunks = 0